import { render, staticRenderFns } from "./BlackDiamond75.vue?vue&type=template&id=2a6579d8&scoped=true"
import script from "./BlackDiamond75.vue?vue&type=script&lang=ts"
export * from "./BlackDiamond75.vue?vue&type=script&lang=ts"
import style0 from "./BlackDiamond75.vue?vue&type=style&index=0&id=2a6579d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6579d8",
  null
  
)

export default component.exports